import React from 'react';
import '../../styles/macAddressInput.css';

/**
 * MAC address input that keeps the format visible while typing:
 * - User's typed content is shown in a noticeable (darker) color
 * - Remaining format characters stay visible as a lighter placeholder
 * @param {string} value - Current value
 * @param {function} onChange - (e) => void
 * @param {string} format - Full placeholder format (e.g. "XX:XX:XX:XX:XX:XX:XX:XX")
 * @param {string} id - Input id for label association
 * @param {string} pattern - HTML pattern for validation
 */
export default function MacAddressInput({ value, onChange, format, id = 'macAddress', pattern }) {

    // Keep format length; show remainder of format after the typed value
    const remainder = value.length < format.length ? format.slice(value.length) : '';

    return (
        <div className="mac-address-input-wrapper">
            <div className="mac-address-input-layer" aria-hidden="true">
                <span className="mac-address-typed">{value}</span>
                <span className="mac-address-placeholder-remainder">{remainder}</span>
            </div>
            <input
                type="text"
                id={id}
                className="mac-address-input"
                value={value}
                onChange={onChange}
                pattern={pattern}
                autoComplete="off"
                spellCheck="false"
                maxLength={format.length}
                aria-label="MAC Address"
            />
        </div>
    );
}
